import { GenIcon } from 'react-icons'

const CmProductBox = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 14 11' },
  child: [
    {
      tag: 'rect',
      attr: {
        x: '0.45',
        y: '5.95',
        width: '13.1',
        height: '4.25789',
        stroke: 'black',
        'stroke-width': '0.9'
      },
      child: []
    },
    {
      tag: 'mask',
      attr: {
        id: 'path-2-inside-1_1283_11850',
        fill: 'white'
      },
      child: [
        {
          tag: 'path',
          attr: {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M4.42108 0.342041H2.21056V2.99468L1.47375 3.2894V5.23677V6.23677H2.21056V6.23678H4.42108V6.23677H5.15797V5.23677V3.2894L4.42108 2.99464V0.342041Z'
          },
          child: []
        }
      ]
    },
    {
      tag: 'path',
      attr: {
        d: 'M2.21056 0.342041V-0.557959H1.31056V0.342041H2.21056ZM4.42108 0.342041H5.32108V-0.557959H4.42108V0.342041ZM2.21056 2.99468L2.54481 3.83031L3.11055 3.60401V2.99468H2.21056ZM1.47375 3.2894L1.1395 2.45377L0.573755 2.68007V3.2894H1.47375ZM1.47375 6.23677H0.573755V7.13677H1.47375V6.23677ZM2.21056 6.23677H3.11055V5.33677H2.21056V6.23677ZM2.21056 6.23678H1.31056V7.13678H2.21056V6.23678ZM4.42108 6.23678V7.13678H5.32108V6.23678H4.42108ZM4.42108 6.23677V5.33677H3.52108V6.23677H4.42108ZM5.15797 6.23677V7.13677H6.05797V6.23677H5.15797ZM5.15797 3.2894H6.05797V2.68007L5.49222 2.45377L5.15797 3.2894ZM4.42108 2.99464H3.52108V3.60397L4.08683 3.83027L4.42108 2.99464ZM2.21056 1.24204H4.42108V-0.557959H2.21056V1.24204ZM3.11055 2.99468V0.342041H1.31056V2.99468H3.11055ZM1.8763 2.15905L1.1395 2.45377L1.80801 4.12503L2.54481 3.83031L1.8763 2.15905ZM0.573755 3.2894V5.23677H2.37375V3.2894H0.573755ZM0.573755 5.23677V6.23677H2.37375V5.23677H0.573755ZM1.47375 7.13677H2.21056V5.33677H1.47375V7.13677ZM3.11055 6.23678V6.23677H1.31056V6.23678H3.11055ZM4.42108 5.33678H2.21056V7.13678H4.42108V5.33678ZM3.52108 6.23677V6.23678H5.32108V6.23677H3.52108ZM4.42108 7.13677H5.15797V5.33677H4.42108V7.13677ZM6.05797 6.23677V5.23677H4.25797V6.23677H6.05797ZM6.05797 5.23677V3.2894H4.25797V5.23677H6.05797ZM5.49222 2.45377L4.75533 2.15901L4.08683 3.83027L4.82371 4.12503L5.49222 2.45377ZM3.52108 0.342041V2.99464H5.32108V0.342041H3.52108Z',
        fill: 'black',
        mask: 'url(#path-2-inside-1_1283_11850)'
      },
      child: []
    },
    {
      tag: 'line',
      attr: {
        x1: '2.94727',
        y1: '2.10249',
        x2: '3.68411',
        y2: '2.10249',
        stroke: 'black',
        'stroke-width': '0.9'
      },
      child: []
    },
    {
      tag: 'mask',
      attr: {
        id: 'path-5-inside-2_1283_11850',
        fill: 'white'
      },
      child: [
        {
          tag: 'path',
          attr: {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M8.10529 0.342041H5.89476V2.99468L5.15796 3.2894V5.23677V6.23677H5.89476V6.23678H8.10529V6.23677H8.84217V5.23677V3.2894L8.10529 2.99464V0.342041Z'
          },
          child: []
        }
      ]
    },
    {
      tag: 'path',
      attr: {
        d: 'M5.89476 0.342041V-0.557959H4.99476V0.342041H5.89476ZM8.10529 0.342041H9.00529V-0.557959H8.10529V0.342041ZM5.89476 2.99468L6.22901 3.83031L6.79476 3.60401V2.99468H5.89476ZM5.15796 3.2894L4.82371 2.45377L4.25796 2.68007V3.2894H5.15796ZM5.15796 6.23677H4.25796V7.13677H5.15796V6.23677ZM5.89476 6.23677H6.79476V5.33677H5.89476V6.23677ZM5.89476 6.23678H4.99476V7.13678H5.89476V6.23678ZM8.10529 6.23678V7.13678H9.00529V6.23678H8.10529ZM8.10529 6.23677V5.33677H7.20529V6.23677H8.10529ZM8.84217 6.23677V7.13677H9.74217V6.23677H8.84217ZM8.84217 3.2894H9.74217V2.68007L9.17642 2.45377L8.84217 3.2894ZM8.10529 2.99464H7.20529V3.60397L7.77103 3.83027L8.10529 2.99464ZM5.89476 1.24204H8.10529V-0.557959H5.89476V1.24204ZM6.79476 2.99468V0.342041H4.99476V2.99468H6.79476ZM5.56051 2.15905L4.82371 2.45377L5.49221 4.12503L6.22901 3.83031L5.56051 2.15905ZM4.25796 3.2894V5.23677H6.05796V3.2894H4.25796ZM4.25796 5.23677V6.23677H6.05796V5.23677H4.25796ZM5.15796 7.13677H5.89476V5.33677H5.15796V7.13677ZM6.79476 6.23678V6.23677H4.99476V6.23678H6.79476ZM8.10529 5.33678H5.89476V7.13678H8.10529V5.33678ZM7.20529 6.23677V6.23678H9.00529V6.23677H7.20529ZM8.10529 7.13677H8.84217V5.33677H8.10529V7.13677ZM9.74217 6.23677V5.23677H7.94217V6.23677H9.74217ZM9.74217 5.23677V3.2894H7.94217V5.23677H9.74217ZM9.17642 2.45377L8.43954 2.15901L7.77103 3.83027L8.50792 4.12503L9.17642 2.45377ZM7.20529 0.342041V2.99464H9.00529V0.342041H7.20529Z',
        fill: 'black',
        mask: 'url(#path-5-inside-2_1283_11850)'
      },
      child: []
    },
    {
      tag: 'line',
      attr: {
        x1: '6.63171',
        y1: '2.10249',
        x2: '7.36856',
        y2: '2.10249',
        stroke: 'black',
        'stroke-width': '0.9'
      },
      child: []
    },
    {
      tag: 'mask',
      attr: {
        id: 'path-8-inside-3_1283_11850',
        fill: 'white'
      },
      child: [
        {
          tag: 'path',
          attr: {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M11.7895 0.342041H9.57896V2.99463L8.84204 3.2894V5.23677V6.23677H9.57896V6.23678H11.7895V6.23677H12.5263V5.23677V3.2894L11.7895 2.99469V0.342041Z'
          },
          child: []
        }
      ]
    },
    {
      tag: 'path',
      attr: {
        d: 'M9.57896 0.342041V-0.557959H8.67896V0.342041H9.57896ZM11.7895 0.342041H12.6895V-0.557959H11.7895V0.342041ZM9.57896 2.99463L9.91321 3.83026L10.479 3.60396V2.99463H9.57896ZM8.84204 3.2894L8.50779 2.45377L7.94204 2.68007V3.2894H8.84204ZM8.84204 6.23677H7.94204V7.13677H8.84204V6.23677ZM9.57896 6.23677H10.479V5.33677H9.57896V6.23677ZM9.57896 6.23678H8.67896V7.13678H9.57896V6.23678ZM11.7895 6.23678V7.13678H12.6895V6.23678H11.7895ZM11.7895 6.23677V5.33677H10.8895V6.23677H11.7895ZM12.5263 6.23677V7.13677H13.4263V6.23677H12.5263ZM12.5263 3.2894H13.4263V2.68007L12.8605 2.45377L12.5263 3.2894ZM11.7895 2.99469H10.8895V3.60402L11.4552 3.83032L11.7895 2.99469ZM9.57896 1.24204H11.7895V-0.557959H9.57896V1.24204ZM10.479 2.99463V0.342041H8.67896V2.99463H10.479ZM9.2447 2.159L8.50779 2.45377L9.17629 4.12503L9.91321 3.83026L9.2447 2.159ZM7.94204 3.2894V5.23677H9.74204V3.2894H7.94204ZM7.94204 5.23677V6.23677H9.74204V5.23677H7.94204ZM8.84204 7.13677H9.57896V5.33677H8.84204V7.13677ZM10.479 6.23678V6.23677H8.67896V6.23678H10.479ZM11.7895 5.33678H9.57896V7.13678H11.7895V5.33678ZM10.8895 6.23677V6.23678H12.6895V6.23677H10.8895ZM11.7895 7.13677H12.5263V5.33677H11.7895V7.13677ZM13.4263 6.23677V5.23677H11.6263V6.23677H13.4263ZM13.4263 5.23677V3.2894H11.6263V5.23677H13.4263ZM12.8605 2.45377L12.1237 2.15906L11.4552 3.83032L12.192 4.12503L12.8605 2.45377ZM10.8895 0.342041V2.99469H12.6895V0.342041H10.8895Z',
        fill: 'black',
        mask: 'url(#path-8-inside-3_1283_11850)'
      },
      child: []
    },
    {
      tag: 'line',
      attr: {
        x1: '10.3159',
        y1: '2.10249',
        x2: '11.0528',
        y2: '2.10249',
        stroke: 'black',
        'stroke-width': '0.9'
      },
      child: []
    }
  ]
})

export default CmProductBox
